"use strict";
import { __require as h } from "./index.es104.js";
import { __require as p } from "./index.es103.js";
var f, o;
function S() {
  if (o) return f;
  o = 1;
  var d = /* @__PURE__ */ h(), v = /* @__PURE__ */ p(), u = function(n, e, i) {
    for (var r = n, t; (t = r.next) != null; r = t)
      if (t.key === e)
        return r.next = t.next, i || (t.next = /** @type {NonNullable<typeof list.next>} */
        n.next, n.next = t), t;
  }, l = function(n, e) {
    if (n) {
      var i = u(n, e);
      return i && i.value;
    }
  }, s = function(n, e, i) {
    var r = u(n, e);
    r ? r.value = i : n.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: e,
      next: n.next,
      value: i
    };
  }, c = function(n, e) {
    return n ? !!u(n, e) : !1;
  }, x = function(n, e) {
    if (n)
      return u(n, e, !0);
  };
  return f = function() {
    var e, i = {
      assert: function(r) {
        if (!i.has(r))
          throw new v("Side channel does not contain " + d(r));
      },
      delete: function(r) {
        var t = e && e.next, a = x(e, r);
        return a && t && t === a && (e = void 0), !!a;
      },
      get: function(r) {
        return l(e, r);
      },
      has: function(r) {
        return c(e, r);
      },
      set: function(r, t) {
        e || (e = {
          next: void 0
        }), s(
          /** @type {NonNullable<typeof $o>} */
          e,
          r,
          t
        );
      }
    };
    return i;
  }, f;
}
export {
  S as __require
};
//# sourceMappingURL=index.es105.js.map
